export type WalletButtonTextMode = 'BUY' | 'CONTINUE' | 'SUBSCRIBE';
